import RestService from './RestService'

export default class TextCompletionService extends RestService {
    constructor() {
        super('text-generator')
    }
}